import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

const SearchItemChip = styled(Chip)(() => ({
    '&': {
        height: '1.5rem',
        borderRadius: '.3rem'
    }
}));

interface IStatusBadgeProps {
    label: string;
}

const StatusBadge: React.FC<IStatusBadgeProps> = (props: IStatusBadgeProps) => {
    return (
        <SearchItemChip
            color="primary"
            label={props.label}
            variant="outlined" />
    );
}

export default StatusBadge;